import React, { useRef, useState } from 'react';
import Card from './Card';
import { Note } from '@/store/notesStore';

interface NoteCardProps {
  note: Note;
  searchQuery?: string;
}

const NoteCardWrapper: React.FC<NoteCardProps> = ({ note, searchQuery }) => {
  const moreBtnRef = useRef<HTMLButtonElement>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  return (
    <Card
      note={note}
      searchQuery={searchQuery}
      cardRef={cardRef}
      moreBtnRef={moreBtnRef}
      dropdownOpen={dropdownOpen}
      setDropdownOpen={setDropdownOpen}
    />
  );
};

export default NoteCardWrapper;
